import { Zap } from 'lucide-react';
import { heroMosaic } from '../mock';

/**
 * Circular photo composition with a central portrait, satellite bubbles
 * and an accent lightning bolt — inspired by getpica's CTA visual.
 */
export default function BubbleComposition() {
  const center = 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/vjzq73nf_v2_951633a9-7ca3-402e-8362-1edc9a2ee9b3%20%281%29.jpg.webp';
  const modeloGirl = 'https://customer-assets-cm19k8pv.emergentagent.net/job_vende-fotos-pro/artifacts/9qecthlj_Gemini_Generated_Image_h8b13rh8b13rh8b1.webp';
  const satellites = [
    { src: modeloGirl, top: '-4%', left: '8%', size: 108 },
    { src: heroMosaic.left[0].src, top: '2%', right: '4%', size: 92 },
    { src: heroMosaic.left[2].src, bottom: '14%', left: '-4%', size: 88 },
    { src: heroMosaic.right[2].src, bottom: '-2%', right: '10%', size: 100 },
    { src: heroMosaic.left[1].src, bottom: '32%', right: '-2%', size: 76 },
  ];

  return (
    <div className="relative w-full max-w-[480px] aspect-square mx-auto">
      {/* Ambient glow behind */}
      <div className="absolute inset-8 rounded-full bg-gradient-to-br from-violet-500/20 via-fuchsia-500/10 to-transparent blur-2xl" />

      {/* Center portrait */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[52%] aspect-square rounded-full overflow-hidden border-4 border-[#0a0a0f] shadow-2xl shadow-black/60 z-10">
        <img src={center} alt="momentIA" className="w-full h-full object-cover" style={{ objectPosition: '50% 25%' }} />
      </div>

      {/* Lightning bolt — anchored to bottom-right of the center circle */}
      <div className="absolute z-20" style={{ top: '62%', left: '62%' }}>
        <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-violet-400 via-fuchsia-400 to-pink-500 flex items-center justify-center shadow-2xl shadow-fuchsia-500/40 border-4 border-[#0a0a0f]">
          <Zap className="w-6 h-6 md:w-7 md:h-7 text-white fill-white" />
          <div className="absolute inset-0 rounded-full bg-white/20 blur-xl -z-10" />
        </div>
      </div>

      {/* Satellite bubbles */}
      {satellites.map((s, i) => (
        <div
          key={i}
          className="absolute rounded-full overflow-hidden border-2 border-[#0a0a0f] shadow-xl shadow-black/50 transition-transform duration-500 hover:scale-110 hover:z-30 z-[5]"
          style={{
            top: s.top,
            left: s.left,
            right: s.right,
            bottom: s.bottom,
            width: `${s.size}px`,
            height: `${s.size}px`,
          }}
        >
          <img src={s.src} alt="momento" className="w-full h-full object-cover" />
        </div>
      ))}

      {/* Decorative dashed arc */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none opacity-25"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="100" cy="100" r="90" stroke="url(#grad)" strokeWidth="0.5" strokeDasharray="2 4" />
        <defs>
          <linearGradient id="grad" x1="0" x2="200" y1="0" y2="200">
            <stop offset="0" stopColor="#a78bfa" />
            <stop offset="1" stopColor="#ec4899" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
